import React from "react";
import style from "./index.module.scss";
import ListItem from "./components/ListItem";
import TopicListHeader from "./components/TopicListHeader";
import { EndExerciseQuestion } from "service/exercise";

interface TopicListProps {
    selectedIndex: number;
    questionList: EndExerciseQuestion[];
}

export default function TopicList({
    selectedIndex,
    questionList
}: TopicListProps) {
    return (
        <div className={style.root}>
            <TopicListHeader />

            {questionList.map((question, index) => (
                <ListItem
                    key={question.id}
                    index={index}
                    data={question}
                    selected={selectedIndex === index}
                />
            ))}
        </div>
    );
}
